import styled from 'styled-components'

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;

  min-width: 100vw;
  min-height: 100vh;

  & > div {
    padding-bottom: 60px;
  }
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;

  img {
    margin-bottom: 20px;
  }

  button {
    width: 100%;
    margin: 0;
    margin-top: 20px;
  }

  .passwordInput input {
    text-security:disc;
    -webkit-text-security:disc;
    -mox-text-security:disc;
  }
`

const LoginOverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;

  min-width: 100vw;
  min-height: 100vh;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999999;
`

const LoginOverlay = styled.div`
  filter: blur(2px);
  min-width: 100vw;
  min-height: 100vh;

  background: white;
  opacity: 0.9;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999999;
`

const ErrorLabel = styled.label`
  color: red;
`

export default {
  LoginContainer,
  FormContainer,
  LoginOverlayContainer,
  LoginOverlay,
  ErrorLabel,
}
